import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { Row, Col, Alert } from 'react-bootstrap'
import * as s from './TeamProfile.scss'
import { getTeamProfile } from '@severed-links/common.redherrings-reducers/football'
import TeamProfileHeader from './TeamProfileHeader'
import DivisionStandings from '../DivisionStandings'
import YouMayRememberMeAs from './YouMayRememberMeAs'
import SeasonSchedule from './SeasonSchedule'
import { getFootballUrlParams } from '@severed-links/common.redherrings-constants'
import { find } from 'lodash'
import Spinner from '@severed-links/common.spinner'

const TeamProfile = () => {

    const dispatch = useDispatch()
    const params = useParams()
    const playerId = useSelector(state => state.account._id)
    const seasons = useSelector(state => state.football.seasons)
    const seasonName = useSelector(state => state.football.seasonName)
    const teamProfiles = useSelector(state => state.football.teamProfiles)
    const c = getFootballUrlParams(params, seasons)

    useEffect(() => { 
        getProfile()
    }, [c.teamId])

    const getProfile = () => c.teamId ? dispatch(getTeamProfile(c.teamId)) : null

    const profile = find(teamProfiles, x => x._id === c.teamId)
    const isMe = profile && profile._id && playerId === profile.playerId

    return (
        profile && !profile.error && profile.teamName ?
        <div className={s.container}>
            <Row className='g-4'>
                <Col xl={7} xs={12}>
                    <TeamProfileHeader profile={profile} playerId={playerId} isMe={isMe} />
                    <Row className='g-4'>
                        <Col lg={6} xs={12}>
                            <DivisionStandings division={profile.divisionStandings}
                                playerId={playerId} shortForm />
                        </Col>
                        <Col lg={6} xs={12}>
                            <YouMayRememberMeAs youMayRememberMeAs={profile.youMayRememberMeAs} />
                        </Col>
                    </Row>
                </Col>
                <Col xl={5} xs={12}>
                    <SeasonSchedule schedule={profile.seasonSchedule} seasonName={seasonName} teamName={profile.teamName} />
                </Col>
            </Row>
        </div>
        : profile && profile.error ? <Alert variant={profile.messageType}>{profile.message}</Alert>
        : <div style={{ padding: '150px 25px', textAlign: 'center' }}><Spinner size='3x' /></div>
    )
}

export default TeamProfile
